export default function Section2() {
    return (
        <div id="section-2">
            <div className="title mt-2">
                Chat at a <span className="text-blue-500">Glance</span>
            </div>
            <div className="text-center w-full">
                Get summaries and instant answers to your questions. Your Go-To PDF AI.
            </div>

            <div className="content">
                <div className="col-2 col">
                    <div className="box">
                        <img src="/assets/LandingSection2Col1.svg"
                        style={{
                            "width": "100%"
                        }}></img>
                        <div className="sub-title">For Professionals</div>
                        <div className="sub-description">
                            Explore contracts, reports, books and more with ChatPDF. Ask it any question and find the answers you need.
                        </div>
                    </div>
                </div>
                <div className="col-2 col">
                    <div className="box">
                    <img src="/assets/LandingSection2Col2.svg"
                    style={{
                        "width": "100%"
                    }}></img>
                    <div className="sub-title">For Students</div>
                    <div className="sub-description">
                        Prepare for your exams and get help for your school assignments
                    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}